import React, { useEffect, useState } from 'react'
import CMS from '../../components/cms/CMS'
import PageBanner from '../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { fetchProductGetAll } from '../../redux/slices/productGetAllSlice'
import { fetchProductDelete } from '../../redux/slices/productDeleteSlice'
import CrudProduct from './CrudProduct'
import { fetchProductSort } from '../../redux/slices/productSortSlice'
import { SortableList } from '../../components/form/SortedBy'

const ProductFamiliesPage = () => {
    const { t } = useTranslation()
    const [modal, setModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const [changed, setChanged] = useState(false)
    const products = useSelector((state) => state.productGetAll.data)
    const status = useSelector((state) => state.productGetAll.status)
    const dispatch = useDispatch()

    const getData = async () => {
        await dispatch(fetchProductGetAll())
        setChanged(false)
    }

    const handleSorted = (newList) => {
        products.forEach(async (oldItem, oldIndex) => {
            const newIndex = newList.findIndex(item => item.id === oldItem.id);
            await dispatch(fetchProductSort({ id: oldItem.id, sort: newIndex + 1 }))
            setChanged(true)
            getData()
        });
    };

    useEffect(() => {
        getData()
    }, [dispatch, changed])

    const deleteData = async (id) => {
        await dispatch(fetchProductDelete({ id: id }))
        getData()
    }

    return (
        <CMS>
            <PageBanner
                modal={modal}
                setModal={setModal}
                title={t("product_families")}
                description={t("product_management_desct")}
                buttonText={t("add_product")}
            />

            {status === "succeeded" ?
                <SortableList
                    setModal={setModal}
                    list={products ? [...products].sort((a, b) => a.sort - b.sort) : []}
                    onChange={handleSorted}
                    setChanged={setChanged}
                    deleteData={deleteData}
                    contentUrl="/product-showcase"
                    setSelectedItem={setSelectedItem}
                /> : null
            }

            <CrudProduct
                showMenu={modal}
                setShowMenu={setModal}
                selectedItem={selectedItem}
                setChanged={setChanged}
                setSelectedItem={setSelectedItem}
                t={t}
            />
        </CMS>
    )
}

export default ProductFamiliesPage
